
import MyCheckbox from '@/components/ui/MyCheckbox.vue';
import { mapGetters } from 'vuex';
import filters from '~/themes/farmacie/mixins/filters';

export default {
    name: 'FastFilters',
    mixins: [filters],
    components: { MyCheckbox },
    props: ['isSearch'],
    data() {
        return {
            activePromoFilters: []
        };
    },
    computed: {
        ...mapGetters({
            promoFilters: 'filters/getPromoFilters',
            activeFiltersToSend: 'filters/activeFiltersToSend'
        }),
        isPromoFilterActive() {
            return this.activeFiltersToSend.filter(filter => !filter?.price);
        }
    },
    methods: {
        changeHandler(filterId, type) {
            this.activePromoFilters = this.activePromoFilters.includes(filterId)
                ? this.activePromoFilters.filter(id => id !== filterId)
                : [...this.activePromoFilters, filterId];
            this.setParameter(filterId, type);
        },
        getValueFormActiveFilters(filterId) {
            return this.activePromoFilters.filter(filter => filter === filterId)[0];
        },
        removeHandler() {
            this.activePromoFilters = [];
            this.removeFilterByType();
        }
    }
};
